import {gettext} from 'utils/text';

export default function toggleAttributes(selector) {
    if (!selector) {
        return;
    }

    const productAttributes = document.querySelectorAll(selector);

    [].forEach.call(productAttributes, (attr) => {
        const readMoreBtn = document.createElement('a');
        readMoreBtn.innerText = gettext('Read more');

        const btnContainer = document.createElement('div');
        btnContainer.classList.add('product-attributes__read-more');
        btnContainer.appendChild(readMoreBtn);

        if (attr.offsetHeight >= 73) {
            attr.classList.add('fade-overflow');
            attr.after(btnContainer);
        }

        readMoreBtn.addEventListener('click', (event) => {
            event.preventDefault();
            const attrToBeShown = event.target.parentNode.previousSibling;
            attrToBeShown.classList.toggle('fade-overflow');
            attrToBeShown.classList.toggle('hide-overflow');

            if (attrToBeShown.classList.contains('hide-overflow')) {
                readMoreBtn.innerText = gettext('Read more');
            } else {
                readMoreBtn.innerText = gettext('Read less');
            }
        });
    });
}



// WEBPACK FOOTER //
// ./src/widgets/ToggleAttributes.js